import React from 'react';
import { motion } from 'framer-motion';
export function PersonalLetter() {
  return <section className="py-8 md:py-20 bg-white" data-id="element-285">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-286">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="prose prose-lg prose-navy max-w-none" data-id="element-287">
          <h2 className="text-3xl md:text-4xl font-serif text-navy mb-8 text-center" data-id="element-288">
            Querida familia,
          </h2>

          <p className="text-lg leading-relaxed text-gray-700 mb-6" data-id="element-289">
            Permíteme hacerte una pregunta que puede cambiar tu vida para
            siempre.
          </p>

          <div className="bg-cream-dark border-l-4 border-gold p-6 my-8 rounded-r-lg" data-id="element-290">
            <p className="font-serif text-xl text-navy italic mb-4" data-id="element-291">
              ¿Qué pasaría hoy... si mañana no pudieras trabajar?
            </p>
            <p className="font-serif text-xl text-navy italic mb-4" data-id="element-292">
              ¿Qué pasaría si una enfermedad inesperada, un accidente, o una
              emergencia médica golpeara tu puerta sin avisar?
            </p>
            <p className="font-serif text-xl text-navy italic font-semibold" data-id="element-293">
              ¿Tienes un plan? ¿Tiene tu familia un plan?
            </p>
          </div>

          <p className="text-lg leading-relaxed text-gray-700 mb-6" data-id="element-294">
            Si dudaste aunque sea un segundo antes de responder... entonces lo
            que estás a punto de leer es exactamente para ti.
          </p>

          <p className="text-lg leading-relaxed text-gray-700 mb-6" data-id="element-295">
            Me llamo <strong data-id="element-296">Anisley Estanque</strong>, y llevo años ayudando a
            familias latinas en Florida, Texas y todo Estados Unidos a construir
            una red de protección sólida, real y accesible para sus seres
            queridos.
          </p>

          <p className="text-lg leading-relaxed text-gray-700 mb-6" data-id="element-297">
            He visto de todo. He visto familias que trabajaron 20 años
            construyendo su estabilidad... destruida en 3 meses por una
            hospitalización sin seguro.
          </p>

          <p className="text-lg leading-relaxed text-gray-700 mb-6" data-id="element-298">
            He visto padres que no pudieron llevar a sus hijos al dentista por
            años... porque "era muy caro"... sin saber que existían planes que
            caben perfectamente en su presupuesto.
          </p>

          <p className="text-lg leading-relaxed text-gray-700 mb-6" data-id="element-299">
            He visto personas perder su visión progresivamente... porque nunca
            tuvieron acceso a un seguro de visión que les cubriera sus lentes o
            sus chequeos anuales.
          </p>

          <p className="text-xl font-serif font-semibold text-navy text-center mt-10" data-id="element-300">
            Y todo eso... <span className="text-gold" data-id="element-301">se puede evitar.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}